<div class="app-container">
  <app-layout></app-layout>
  
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>

